import './App.css';
import { CopyCatContainer } from '../../Containers/CopyCatContainer/CopyCatContainer';

function App() {
  return <CopyCatContainer />;
}

export default App;
